import { AlignTypes } from "@monorepo-web/components-library";
export const getLayouts = (titles) => {
    const columns = {
        'default': [
            { id: 'mesano', label: 'Mês/Ano', freeze: true },
            { id: 'saldoIni', label: 'Saldo Inicial (A)', align: AlignTypes.right },
            { id: 'aplicacoes', label: 'Aplicações (B)', align: AlignTypes.right },
            { id: 'resgates', label: 'Resgates (C)', align: AlignTypes.right },
            { id: 'impostos', label: 'Impostos Pagos (D)', align: AlignTypes.right },
            { id: 'saldoMovim', label: 'Saldo Movimentações (E=B-C)', align: AlignTypes.right },
            { id: 'rendNominal', label: 'Rendimento Nominal (F)', align: AlignTypes.right },
            { id: 'saldoFim', label: 'Saldo Final (G=A-D+E+F)', align: AlignTypes.right },
        ],
        'reduzido': [
            { id: 'mesano', label: 'Mês/Ano', freeze: true },
            { id: 'aplicacoes', label: 'Aplicações no Período', align: AlignTypes.right },
            { id: 'resgates', label: 'Resgates no Período (Bruto)', align: AlignTypes.right },
            { id: 'saldoMovim', label: 'Saldo Movimentações', align: AlignTypes.right },
            { id: 'saldoFim', label: 'Saldo Bruto', align: AlignTypes.right },
        ]
    };
    if (titles) {
        titles === null || titles === void 0 ? void 0 : titles.forEach((titulo, index) => {
            columns['default'][index].label = titulo;
        });
    }
    return columns;
};
